import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { DispersionesService } from 'src/app/services/dispersiones.service';
import { MensajeModalComponent } from '../utils/mensaje-modal/mensaje-modal.component';
import { CustomValidators } from 'src/app/validations/custom-validators';

@Component({
  selector: 'app-departamentos-form-modal',
  templateUrl: './departamentos-form-modal.component.html'
})
export class DepartamentosFormModalComponent implements OnInit {

  public formDepartamento: FormGroup;

  public modalOptions: NgbModalOptions;

  constructor(private spinner: NgxSpinnerService,
    private dispersionesService: DispersionesService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal) {
    this.formDepartamento = this.createFormDepartamento();
  }

  ngOnInit(): void {
    this.modalOptions = {
      backdrop: 'static',
      centered: true,
      keyboard: false,
      size: 'sm'
    }
  }

  private createFormDepartamento(): FormGroup {
    return this.formBuilder.group({
      nombre: [null, Validators.compose([
        Validators.required,
        Validators.maxLength(100),
        CustomValidators.patternValidator(/^(?![0-9\s]+$)[\s0-9a-zA-ZÑñÁáÉéÍíÓóÚú_*()&+-]*$/, { isInvalidNombre: true })
      ])]
    });
  }

  public guardarDepartamento() {
    this.spinner.show();
    if (this.formDepartamento.valid) {
      const nombre = this.formDepartamento.get('nombre').value;
      this.dispersionesService.insertDepartamento(nombre).subscribe(
        response => {
          const resp = response.body;
          if (resp) {
            this.mostrarMensajeModal('Guardado', 'El registro fue cargado correctamente.', true);
          }
        }, error => {
          console.log(error);
          this.mostrarMensajeModal('Error', error.error.errorMessage);
        }
      );
    } else {
      let mensajeModal = '';
      if (this.formDepartamento.get('nombre').hasError('required')) {
        mensajeModal = 'El nombre es obligatorio.';
      }
      if (this.formDepartamento.get('nombre').hasError('maxLength')) {
        mensajeModal = 'El nombre es de maximo 40 caracteres.';
      }
      if (this.formDepartamento.get('nombre').hasError('isInvalidNombre')) {
        mensajeModal = 'El nombre no puede ser númerico.';
      }
      this.mostrarMensajeModal('Error', mensajeModal);
    }
  }

  public cancelar() {
    this.activeModal.close();
  }

  public mostrarMensajeModal(tituloModal: string, mensajeModal: string, cerrarModal?: boolean) {
    const modalMensaje = this.modalService.open(MensajeModalComponent, this.modalOptions);
    modalMensaje.componentInstance.tituloModal = tituloModal;
    modalMensaje.componentInstance.mensajeModal = mensajeModal;
    modalMensaje.result.then(() => {
      if (cerrarModal) {
        this.activeModal.close();
      }
    });
  }

}
